import { faCalculator, faCompressAlt, faExpandAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import "./SimuladorNFSe.css";

const SIMULADOR_URL = `${process.env.PUBLIC_URL || ""}/simulador-nfse.html`;

function SimuladorNFSe({ theme }) {
  const [open, setOpen] = useState(false);
  const [wasOpened, setWasOpened] = useState(false);
  const [maximized, setMaximized] = useState(false);
  const [pos, setPos] = useState(null);
  const drag = useRef(null);

  const toggle = () => {
    setOpen((v) => !v);
    setWasOpened(true);
  };

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const onPointerDown = (e) => {
    if (maximized || e.target.closest("button")) return;
    const rect = e.currentTarget.parentElement.getBoundingClientRect();
    drag.current = { dx: e.clientX - rect.left, dy: e.clientY - rect.top };
    e.currentTarget.setPointerCapture(e.pointerId);
  };
  const onPointerMove = (e) => {
    if (!drag.current) return;
    setPos({
      left: Math.max(0, Math.min(window.innerWidth - 120, e.clientX - drag.current.dx)),
      top: Math.max(0, Math.min(window.innerHeight - 48, e.clientY - drag.current.dy)),
    });
  };
  const onPointerUp = () => {
    drag.current = null;
  };

  const style = !maximized && pos ? { left: pos.left, top: pos.top, right: "auto", bottom: "auto" } : undefined;

  return (
    <>
      <button
        type="button"
        className="btn-simulador-nfse"
        style={{ background: theme }}
        onClick={toggle}
        title="Simulador NFS-e"
      >
        <FontAwesomeIcon icon={faCalculator} />
        <span>Simulador NFS-e</span>
      </button>

      {wasOpened && (
        <div
          className={`simulador-nfse-janela${maximized ? " maximizada" : ""}`}
          style={{ ...style, display: open ? "flex" : "none" }}
          role="dialog"
          aria-label="Simulador NFS-e"
        >
          <div
            className="simulador-nfse-header"
            style={{ background: theme }}
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={onPointerUp}
            onDoubleClick={() => setMaximized((v) => !v)}
          >
            <span>Simulador NFS-e</span>
            <div>
              <button type="button" onClick={() => setMaximized((v) => !v)} title={maximized ? "Restaurar" : "Maximizar"}>
                <FontAwesomeIcon icon={maximized ? faCompressAlt : faExpandAlt} />
              </button>
              <button type="button" onClick={() => setOpen(false)} title="Fechar">
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>
          <iframe className="simulador-nfse-frame" src={SIMULADOR_URL} title="Simulador NFS-e" />
        </div>
      )}
    </>
  );
}

export default SimuladorNFSe;
